
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";

export interface PaymentStep {
  id: string;
  title: string;
  description: string;
  status: "pending" | "processing" | "completed" | "error";
  icon: string;
}

@Component({
    selector: "app-payment-processing-overlay",
    imports: [],
    templateUrl: "./payment-processing-overlay.component.html",
    styleUrls: ["./payment-processing-overlay.component.scss"]
})
export class PaymentProcessingOverlayComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() isVisible: boolean = false;
  @Input() currentStep: string = "";
  @Input() errorMessage: string = "";
  @Input() paymentMethod: "credit_card" | "pix" = "credit_card";

  private destroy$ = new Subject<void>();

  steps: PaymentStep[] = [
    {
      id: "validating",
      title: "Validando dados",
      description: "Verificando informações do pagamento",
      status: "pending",
      icon: "fas fa-check-circle",
    },
    {
      id: "processing",
      title: "Processando pagamento",
      description: "Conectando com o provedor de pagamento",
      status: "pending",
      icon: "fas fa-credit-card",
    },
    {
      id: "confirming",
      title: "Confirmando pagamento",
      description: "Validando transação com o banco",
      status: "pending",
      icon: "fas fa-shield-alt",
    },
    {
      id: "finalizing",
      title: "Finalizando compra",
      description: "Gerando seus ingressos",
      status: "pending",
      icon: "fas fa-ticket-alt",
    },
  ];

  @Output() closeOverlayClick = new EventEmitter();

  @HostListener("document:keydown.escape", ["$event"])
  onEsc(event: KeyboardEvent) {
    event.preventDefault();
    this.handleCloseOverlayClick();
  }

  ngOnInit(): void {
    this.updateStepsStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["currentStep"] || changes["errorMessage"]) {
      console.log("🔄 PaymentProcessingOverlay: Mudança detectada", {
        currentStep: this.currentStep,
        errorMessage: this.errorMessage,
      });
      this.updateStepsStatus();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleCloseOverlayClick() {
    if (this.errorMessage) {
      this.closeOverlayClick.emit();
    }
  }

  updateStepsStatus(): void {
    const currentStepIndex = this.getCurrentStepIndex();

    console.log("🔄 PaymentProcessingOverlay: Atualizando status das etapas", {
      currentStep: this.currentStep,
      currentStepIndex: currentStepIndex,
      errorMessage: this.errorMessage,
    });

    this.steps.forEach((step, index) => {
      if (index < currentStepIndex) {
        step.status = "completed";
      } else if (index === currentStepIndex) {
        step.status = this.errorMessage ? "error" : "processing";
      } else {
        step.status = "pending";
      }

      console.log(`🔄 Etapa ${step.id}: ${step.status}`);
    });
  }

  private getCurrentStepIndex(): number {
    switch (this.currentStep) {
      case "validating":
        return 0;
      case "processing":
        return 1;
      case "confirming":
        return 2;
      case "finalizing":
        return 3;
      default:
        return 0;
    }
  }

  getStepIcon(step: PaymentStep): string {
    if (step.status === "completed") {
      return "fas fa-check-circle";
    } else if (step.status === "error") {
      return "fas fa-exclamation-circle";
    } else if (step.status === "processing") {
      return "fas fa-spinner fa-spin";
    }
    return step.icon;
  }

  getStepClass(step: PaymentStep): string {
    return `payment-step payment-step--${step.status}`;
  }

  getPaymentMethodIcon(): string {
    return this.paymentMethod === "credit_card"
      ? "fas fa-credit-card"
      : "fas fa-qrcode";
  }

  getPaymentMethodText(): string {
    return this.paymentMethod === "credit_card" ? "Cartão de Crédito" : "PIX";
  }

  onCancel(): void {
    // Emitir evento de cancelamento se necessário
    console.log("Pagamento cancelado pelo usuário");
  }
}
